import fetch from "../utils/fetch";
import { environment } from '../environment';

import throwAPIErrors from "./middleware/throw-api-errors";
import authorizationHeader from "./middleware/authorization-header";
import requestTokenHeader from "./middleware/request-token-header";
import retry from "./middleware/retry";
import debugHeader from "./middleware/debug-header";
import applyMiddleware from "./middleware/apply-middleware";

const firstSlash = /^\//g;

const fetchTradeAPI = (url, opts = {}) => {
  const urlToTradeApi = `${environment.tradeAPIRoot}/${url.replace(
    firstSlash,
    ""
  )}`;
  return fetch(urlToTradeApi, opts);
};

export default applyMiddleware([
  authorizationHeader,
  requestTokenHeader,
  retry(/401/),
  throwAPIErrors(/[4-5]\d\d/),
  debugHeader
])(fetchTradeAPI);
